import { useAppSelector } from "src/store/hooks";

import { WsStatusTypes } from "src/types";

export default function StatusBar() {
  const { wsStatus } = useAppSelector((state) => state.context);
  const { queues } = useAppSelector((state) => state.config);

  const colorRef = {
    [WsStatusTypes.CONNECTED]: "bg-lime-400",
    [WsStatusTypes.CONNECTING]: "bg-yellow-300",
    [WsStatusTypes.DISCONNECTED]: "bg-red-600",
    [WsStatusTypes.ERROR]: "bg-stone-950",
  };

  return (
    <ul className="dark:bg-neutral-gray-800 bg-neutral-gray-5 status-bar rounded-lg py-4 px-6 text-neutral-gray-600 text-base">
      <li className="flex items-center capitalize dark:text-neutral-gray-50">
        <span
          className={`w-2 h-2 block mr-2 ${colorRef[wsStatus]} rounded-full`}
        ></span>
        {queues.join(" • ")}
      </li>
    </ul>
  );
}
